import React, { useEffect, useMemo, useReducer, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
 
// style
import { FilterControlStore, FilterControlTime, WrapFilterTransaction, WrapFilterTransactionCheckbox, WrapFilterTransactionControl, WrapFilterTransactionSearch } from '../../Bank/FilterTransactionBank/index.styles';

// images
import IcUnCheckBox from '../../../../../../../assets/images/IcUnCheckBox';
import IcCheckBoxActive from '../../../../../../../assets/images/IcCheckBoxActive';
import IcCheckBoxDisabled from '../../../../../../../assets/images/IcCheckBoxDisabled';
import IcRefresh from '../../../../../../../assets/images/IcRefresh';
import IcArrowDownGray from '../../../../../../../assets/images/IcArrowDownGray';
import IcCalendarActive from '../../../../../../../assets/images/IcCalendarActive';
import IcStoreActive from '../../../../../../../assets/images/IcStoreActive';

// component
import DropdownFilterBank from '../../Bank/FilterTransactionBank/DropdownFilterBank';
import DropdownFilterTime from '../../Bank/FilterTransactionBank/DropdownFilterTime';
import DropdownFilterStore from '../../Bank/FilterTransactionBank/DropdownFilterStore';
import FilterControl from '../../../../../../Control/FilterControl';
import Button from '../../../../../../Control/Button';
import CheckBoxControl from '../../../../../../Control/CheckBoxControl';
import InputDropdownBank from '../../../CustomerV2/CustomerList/BankCustomerList/FilterBankBlock/InputDropDownBank';

// keys
import { FACEPAYTERMINAL } from '../../index'
import { BANK_TX_ID, FACEPAY_TX_ID, MERCHANT_TX_ID, PHONE_NUMBER, PROFILE_ID, VOUCHER } from '../../../../../../../constant/keys';

// redux
import { getListStoreName, hidePopupDropdownStoreName, resetCondFiltersStoreName, resetIsCheckSearchStore, showPopupDropdownStoreName } from '../../../../../../../redux/transactionV2/transactionOther/action';
import { resetCondFiltersTransactionFacepay, updateCondFiltersTransactionFacepay } from '../../../../../../../redux/transactionV2/listTransactionFacepayTerminal/action';
import { currentDay, startDay } from '../../../../../../../redux/transactionV2/listTransactionBank/listTransactionBankReducer';

// dataa
import { dataSwiftCodeBankFacepay } from '../../../../../../../constant/dataSwiftCodeBank';
import { dataSelectCheckbox } from '../../../../../../../data/dataSelectCheckbox';

// helper
import DatePickerTransaction from '../../Bank/FilterTransactionBank/DatePickerTransaction';
import InputSearchTransaction from '../../Bank/FilterTransactionBank/InputSearchTransaction';

const iconCheckBox = {
    icon: IcUnCheckBox,
    iconActive: IcCheckBoxActive,
    iconDisabled: IcCheckBoxDisabled
};

const FilterTransactionFacepay = () => {

    const dispatch = useDispatch()

    const { condFiltersTransactionFacepay, condFiltersStoreName, isShowDropdownListStore, listStoreName } = useSelector((state) => ({
        // bank
        condFiltersTransactionFacepay: state.transactionReducer.listTransactionFacepayReducer.condFiltersTransactionFacepay,
        // storename
        condFiltersStoreName: state.transactionReducer.transactionOtherReducer.condFiltersStoreName,
        isShowDropdownListStore: state.transactionReducer.transactionOtherReducer.isShowDropdownListStore,
        listStoreName: state.transactionReducer.transactionOtherReducer.listStoreName,

    }))
    const [valueSearch, setValueSearch] = useState('')

    const [filterCondTransaction, setFilterCondTransaction] = useState(condFiltersTransactionFacepay.OptionSelect)
    const [filterCondTransactionTime, setFilterCondTransactionTime] = useState(condFiltersTransactionFacepay.OptionSelectTime)

    const [data, setData] = useReducer(
        (state, action) => ({...state, ...action}), 
        {
            limit: condFiltersTransactionFacepay.limit,
            lastItemId: condFiltersTransactionFacepay.lastItemId,
            bankTrxCode: condFiltersTransactionFacepay.bankTrxCode,
            facepayTrxCode: condFiltersTransactionFacepay.facepayTrxCode,
            merchantTrxCode: condFiltersTransactionFacepay.merchantTrxCode,
            phoneNumber: condFiltersTransactionFacepay.phoneNumber,
            profileId: condFiltersTransactionFacepay.profileId,
            code: condFiltersTransactionFacepay.code,
            storeId: condFiltersTransactionFacepay.storeId,
            OptionSelectCheckbox: condFiltersTransactionFacepay.OptionSelectCheckbox,
            supplier: condFiltersTransactionFacepay.supplier,
            begin: condFiltersTransactionFacepay.begin,
            end: condFiltersTransactionFacepay.end,
        }
    )

    const _handleChangeOptionFilter = (filterOption) => {
        setFilterCondTransaction(filterOption)
        setValueSearch("")
    }

    const _handleChangeOptionFilterTime = (filterOption) => {
        setFilterCondTransactionTime(filterOption)
    }

    const _handleSearch = () => {
        const { key } = filterCondTransaction
        let bankTrxCode = ""
        let facepayTrxCode = ""
        let merchantTrxCode = ""
        let profileId = ""
        let phoneNumber = ""
        let code = ""
        switch (key) {
          case BANK_TX_ID: {
            bankTrxCode = valueSearch
            break;
          }
          case FACEPAY_TX_ID: {
            facepayTrxCode = valueSearch
            break;
          }
          case MERCHANT_TX_ID: {
            merchantTrxCode = valueSearch
            break;
          }
          case PROFILE_ID: {
            profileId = valueSearch
            break;
          }
          case PHONE_NUMBER: {
            phoneNumber = valueSearch
            break;
          }
          case VOUCHER: {
            code = valueSearch
            break;
          }
          default:
            return;
        }
        dispatch(updateCondFiltersTransactionFacepay({
            ...condFiltersTransactionFacepay,
            bankTrxCode,
            facepayTrxCode,
            merchantTrxCode,
            profileId,
            phoneNumber,
            code
        }))
    }

    const dropdownFilterBank = useMemo(() => (
        <DropdownFilterBank
            reqType={FACEPAYTERMINAL}
            filterCond={filterCondTransaction}
            setFilterCond={_handleChangeOptionFilter}
        />
    ),[filterCondTransaction])

    const dropdownFilterTime = useMemo(() => (
        <DropdownFilterTime 
            filterCond={filterCondTransactionTime}
            setFilterCond={_handleChangeOptionFilterTime}
        />
    ),[filterCondTransactionTime])

    const dropdownFilterStore = useMemo(() => (
        <DropdownFilterStore
            reqType={FACEPAYTERMINAL}
            listStoreName={listStoreName}
            iconCheckBox={iconCheckBox}
            onClosePopup={() => dispatch(hidePopupDropdownStoreName())}
        />
    ),[listStoreName])
    
    const filterComponent = useMemo(() => (
        <InputSearchTransaction 
            filterCondTransaction={filterCondTransaction}
            valueSearch={valueSearch}
            setValueSearch={setValueSearch}
        />
    ),[filterCondTransaction, _handleSearch])

    const filterComponentTime = useMemo(() => (
        <DatePickerTransaction
            filterCondTransactionTime={filterCondTransactionTime}
            setFilterCondTransactionTime={setFilterCondTransactionTime}
            data={data}
            setData={setData}
            condFiltersTransaction={condFiltersTransactionFacepay}
            reqType={FACEPAYTERMINAL}
        />
    ),[filterCondTransactionTime, data.begin, data.end])
    
    const handleSelectCheckboxBank = (checkboxSelected) => {
        if(!condFiltersTransactionFacepay.supplier) return
        let checkboxCollection = condFiltersTransactionFacepay.supplier.map((item, index) => {
            if(index !== checkboxSelected){
                return {
                    ...item
                }
            }else {
                return {
                    ...item,
                    isSelect: !item.isSelect
                }
            }
        })
        dispatch(updateCondFiltersTransactionFacepay({
            ...condFiltersTransactionFacepay,
            supplier: checkboxCollection
        }))
        
    }

    const handleSelectCheckbox = (checkboxSelected) => {
        if(!condFiltersTransactionFacepay.OptionSelectCheckbox) return
        let checkboxCollection = condFiltersTransactionFacepay.OptionSelectCheckbox.map((item) => {
            if(item.id !== checkboxSelected){
                return {
                    ...item
                }
            }else {
                return {
                    ...item,
                    isSelect: !item.isSelect
                }
            }
        })

        dispatch(updateCondFiltersTransactionFacepay({
            ...condFiltersTransactionFacepay,
            OptionSelectCheckbox: checkboxCollection
        }))

    }
    
    const handleRefresh = () => {
        const callbackSuccess = () => {
            dispatch(getListStoreName({
                name: [""]
              }))
        }
        setFilterCondTransactionTime(condFiltersTransactionFacepay.OptionSelectTime)
        setData({
            begin: startDay,
            end: currentDay,
        })
        dispatch(resetCondFiltersTransactionFacepay())
        dispatch(resetIsCheckSearchStore())
        dispatch(resetCondFiltersStoreName(callbackSuccess))
        setValueSearch("")
    }
    
    return (
        <WrapFilterTransaction>
            <WrapFilterTransactionSearch>
                <WrapFilterTransactionControl>
                    <FilterControl
                        className='input-transaction'
                        dropdownFilter={dropdownFilterBank}
                        filterComponent={filterComponent}
                        handleSearch={_handleSearch}
                        value={valueSearch}
                        isShowSubmitBtn={true}
                    />
                    <FilterControlTime>
                        <IcCalendarActive />
                        {dropdownFilterTime}
                        {filterComponentTime}
                    </FilterControlTime>
                    <FilterControlStore>
                        <div className="store-title" >
                            <div className="title">
                                <IcStoreActive /> 
                                <p className="value-title">Cửa hàng: </p>
                            </div>
                            <div className="value" onClick={() => dispatch(showPopupDropdownStoreName())}>{condFiltersStoreName.OptionSelectStore.isSelect ? condFiltersStoreName.OptionSelectStore.name : `Đã chọn ${condFiltersStoreName.OptionSelectStore.totalStoreSelect} cửa hàng` }</div>
                            <IcArrowDownGray className="arrow-right" onClick={() => dispatch(showPopupDropdownStoreName())} />
                        </div>
                        {isShowDropdownListStore && dropdownFilterStore}
                    </FilterControlStore>
                </WrapFilterTransactionControl>
                <Button
                    iconBtn={<IcRefresh />}
                    text="Reset"
                    className="btn-reset"
                    onClick={handleRefresh}
                /> 
            </WrapFilterTransactionSearch>
            <WrapFilterTransactionCheckbox>
                <div className="filter-checkbok">
                    {
                        condFiltersTransactionFacepay.OptionSelectCheckbox.map((item, index) => (
                            <CheckBoxControl 
                                key={index}
                                title={item.name}
                                iconCheckBox={iconCheckBox}
                                className="info-check"
                                isChecked={item.isDisabled !== true && item.isSelect}
                                handleCheck={() => handleSelectCheckbox(item.id)}
                                isDisabled={item.isDisabled === true ? true : false}
                            />
                        ))
                    }
                </div>
                <div className="filter-checkbok">
                    <div className="filter-checkbok-text">Phương thức thanh toán: </div>
                    <div className="filter-checkbok-bank">
                        <InputDropdownBank
                            reqType={FACEPAYTERMINAL}
                            iconCheckBox={iconCheckBox}
                            listDropdown={condFiltersTransactionFacepay.supplier}
                            listChecked={condFiltersTransactionFacepay.supplier.filter((item) => item.isSelect).map((item) => item.key)}
                            handleCheckItem={handleSelectCheckboxBank}
                        />
                    </div>
                </div>
            </WrapFilterTransactionCheckbox>
        </WrapFilterTransaction>
    )
}

export default FilterTransactionFacepay
